import React from 'react';

import InfoPageSkeleton from '../../components/skeleton/InfoPageSkeleton';
import createRouteLoadable from './createRouteLoadable';

export const INFO_PAGE_CHUNK_NAME = 'infoPage';

export const InfoPage = createRouteLoadable(
  () => import(/* webpackChunkName: "infoPage" */ '../../pages/InfoPage'),
  {
    fallback: <InfoPageSkeleton />,
  }
);
